import React from 'react';
import { noop } from "../../utils/noop";
export var PopoverContext = React.createContext({
  onRequestClose: noop,
  color: 'secondary'
});